import * as React from 'react';
import { Helper } from '../../../../Helper';
import * as styles from './PeopleCard.css';
import { ConditionalOutput } from '../../../../services/ConditionalOutput';
import { ConditionalOutputFactory } from "../../../../services/ConditionalOutputFactory";
import { MSPersonCard } from '../../../msPersonCard/MSPersonCard';
import { IAIcon } from '../../../icon/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { IFontSlots } from '../../../../interfaces/IFontSlots';
library.add(fab, fas, far);



export interface IPeopleCardProps {
  properties: IPeopleCardProperties[];
  image?: string;
  backgroundColor: string;
  linkedTextColor?: string;
  index?: number;
  nameLink?: string;
  tenant?: string;
  highlightColor?: string;
  fontSlots?: IFontSlots;
}

export interface IPeopleCardProperties {
  property?: string;
  value?: string;
  iconTitle?: string;
  iconColor?: string;
  classNames?: string[];
  link?: string;
  icon?: string;
  iconSize?: number;
  templateLink?: any;
}


export class PeopleCard extends React.Component<IPeopleCardProps> {

  public render() {
    let firstNameChar: string;
    let lastNameChar: string;
    let nameProperty: IPeopleCardProperties = {};
    let result = [];
    let email: string;
    const linkedColor: string = this.props.linkedTextColor;
    if (this.props.properties) {
      result = this.props.properties.map((property: IPeopleCardProperties, index: number) => {
        if (property.property === 'PreferredName') {
          if (!!nameProperty) { nameProperty = property; }
          return undefined;
        }
        if (property.property === "WorkEmail" && Helper.isEmail(property.value)) {
          email = property.value;
        }

        if (property.property === 'Path' && nameProperty) {
          return (<div key={index}></div>);
        }
        return (
          <div key={index}>
            <div className={styles.IA_credential_icons}>
              {property.iconTitle ?
                <IAIcon
                  url={property.iconTitle}
                  size={20}
                  color={property.iconColor}
                  style={{
                    marginTop: 2
                  }}
                />
                :
                <div
                  style={{
                    width: 20,
                    fontSize: 16,
                    paddingLeft: 2,
                    boxSizing: "border-box"
                  }}
                >
                  {/* @ts-ignore */}
                  < FontAwesomeIcon icon={property.icon?.includes("-o") ? `fa-regular ${property.icon?.replace("-o", "")}` : `fa ${property.icon}`} color={property.iconColor} />
                </div>
                // <div
                //   className={`fa ${property.icon}`}
                //   style={{
                //     width: 20,
                //     marginTop: -1,
                //     color: property.iconColor,
                //     fontSize: 16,
                //     paddingLeft: 2,
                //     boxSizing: "border-box"
                //   }}
                // />
              }
            </div>
            <div
              className={property.classNames?.join() || undefined}
              style={{
                fontSize: 14,
                display: 'flex',
                marginTop: 2
              }}
            >
              {ConditionalOutputFactory
                .WithDefault(<div>{property.value}</div>)
                .OnCondition(
                  (property.property === 'WorkEmail' ||
                    property.property === 'TelefonbogMail' ||
                    property.property === 'MobilePhone' ||
                    property.property === 'WorkPhone')
                  ,
                  <a href={`${property.link != null ? property.link : ((property.property === 'MobilePhone' || property.property === 'WorkPhone') ? "tel:" : "mailto:")}${property.value}`} className={styles.IA_credential_onHover} style={{ textDecoration: "none", color: linkedColor }} target="_blank">
                    {property.value}
                  </a>)
                .OnCondition(property.link === 'tel:' && property.templateLink === null,
                  property.value.split('/').map((number, arrayIndex) => {
                    return (
                      <div key={arrayIndex}>
                        <a href={`${property.link}${number}`} className={styles.IA_credential_onHover} style={{ textDecoration: "none", color: linkedColor, float: 'left' }} target="_blank">
                          {number}
                        </a> {new ConditionalOutput(<div style={{ float: "left", marginLeft: 3, marginRight: 3 }}>/</div>)
                          .OnCondition(property.value.split('/').length - 1 === arrayIndex,
                            <div></div>)
                          .Last()}
                      </div>
                    )
                  }))
                .OnCondition(property.templateLink !== null,
                  <a href={property.templateLink} style={{ textDecoration: "none", color: linkedColor }} target="_blank">
                    {property.value}
                  </a>)
                .Last()}
            </div>
          </div>
        );
      });
      firstNameChar = nameProperty?.value?.split(' ')[0][0];
      const lastName: string = nameProperty?.value?.split(' ')[nameProperty.value?.split(' ').length - 1];
      lastNameChar = nameProperty?.value?.split(' ')[0] !== lastName ? lastName[0] : firstNameChar;
      result.unshift(
        <MSPersonCard
          userLoginName={email}
          userProfileImage={this.props.image}
          highlightColor={this.props.highlightColor}
        >
          <div key={`card:${this.props.index}${nameProperty.property}`} className={nameProperty.classNames?.join(' ')}>
            <p
              onClick={() => {
                Helper.openProfilePageWithImageUrl(email, this.props.image);
              }}
              style={{ textDecoration: "none", fontSize: 17, color: this.props.highlightColor, fontFamily: this.props.fontSlots?.heading?.fontFamily }}>
              {nameProperty.value}
            </p>
          </div>
        </MSPersonCard>
      );
    }

    return (
      <div
        className={styles.IA_peopleCard}
        style={{
          fontFamily: this.props.fontSlots?.body?.fontFamily
        }}
      >
        <MSPersonCard
          userLoginName={email}
          userProfileImage={this.props.image}
          highlightColor={this.props.highlightColor}
        >
          <div
            className={styles.IA_personaSmallProfileImageWrapper}
            style={{
              backgroundColor: new ConditionalOutput(this.props.backgroundColor)
                .OnCondition(!this.props.backgroundColor, '#333')
                .Last(),
              color: new ConditionalOutput(Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#ffffff", "#333333"))
                .OnCondition(!this.props.backgroundColor, '#fff')
                .Last()
            }}
            onClick={() => {
              Helper.openProfilePageWithImageUrl(email, this.props.image);
            }}
          >
            <div
              className={styles.IA_personaSmallProfileImageText}
            >
              {firstNameChar + lastNameChar}
            </div>
            <div
              className={styles.IA_personaSmallProfileImage}
              style={{
                backgroundImage: `url('${this.props.image ? this.props.image : ""}')`
              }} />
          </div>
        </MSPersonCard>
        <div className={styles.IA_peopleCard_content} >
          {result}
        </div>
      </div>);
  }
}            